import React from 'react'
import { useDynamicList } from 'ahooks'
import useBemClass from '@/utils/hooks/useBEMClass'
import Iconfont from '@/components/iconfont/iconfont'
import { SortableElement, SortableContainer } from 'react-sortable-hoc'
import { Row, Column } from '@/components/layout/layout'
import { Modal } from '@/components/dialog/modal'
import { layerManage } from '@/utils/layer'
import $msg from '@/utils/message'
import './goods-sort.scss'
import { useState } from 'react'

interface ISortItem {
    key: string
    title: string
    checked: boolean
    onCheck: () => void
}

const SortItem: React.FC<ISortItem> = props => {
    const cls = useBemClass('goods-sort')

    return (
        <div className={cls('item')}>
            <Row data-align-items-center>
                <div data-cursor-pointer onClick={props.onCheck}>
                    <Iconfont name={props.checked ? 'iconduoxuanquanxuan-20' : 'iconduoxuanguan-20'} size={20} />
                </div>
                <div data-color-000 data-font-size-16 data-margin-left-16>
                    {props.title}
                </div>
            </Row>
            <div className={cls('item', 'right')}>
                <Iconfont name="icontuodong" size={24} />
            </div>
        </div>
    )
}

const SortItems = SortableElement(SortItem)

type ISortData = Array<{
    title: string
    key: string
    checked: boolean
}>

interface SortContainerProps {
    sortData: ISortData
    onSortEnd: (data: ISortData) => void
}

interface GoodTableSortContainerProps {
    sortData: ISortData
    checkImg: boolean
    onSortEnd: (data: ISortData, checkImg: boolean) => void
}

export const GoodTableSortContainer: React.FC<GoodTableSortContainerProps> = props => {
    const [checkImg, setCheckImg] = useState<boolean>(props.checkImg)

    return (
        <SortContainer
            sortData={props.sortData}
            onSortEnd={data => {
                props.onSortEnd(data, checkImg)
            }}
        >
            <Row data-align-items-center data-height-50>
                <div
                    style={{
                        cursor: 'pointer',
                        marginLeft: '25px',
                    }}
                    onClick={() => {
                        setCheckImg(v => !v)
                    }}
                >
                    <Iconfont name={checkImg ? 'iconduoxuanquanxuan-20' : 'iconduoxuanguan-20'} size={20} />
                </div>
                <div data-color-000 data-font-size-16 data-margin-left-16>
                    图片
                </div>
                <div
                    style={{
                        cursor: 'not-allowed',
                        opacity: 0.4,
                        marginLeft: '156px',
                    }}
                >
                    <Iconfont name="iconduoxuanquanxuan-20" size={20} />
                </div>
                <div data-color-000 data-font-size-16 data-margin-left-16>
                    商品名称
                </div>
            </Row>
        </SortContainer>
    )
}

const SortContainer: React.FC<SortContainerProps> = props => {
    const cls = useBemClass('goods-sort')

    const { list, move, replace } = useDynamicList<{
        title: string
        key: string
        checked: boolean
    }>(props.sortData)

    const SortList = SortableContainer(() => (
        <Row className={cls()}>
            {list.map((l, i) => (
                <SortItems
                    // @ts-ignore
                    key={l.key}
                    index={i}
                    {...l}
                    onCheck={() => {
                        replace(i, {
                            ...list[i],
                            checked: !list[i].checked,
                        })
                    }}
                />
            ))}
        </Row>
    ))

    return (
        <Modal
            type="success"
            isShow
            title="列表条目显示设置"
            onClose={() => layerManage.pop()}
            onCancel={() => layerManage.pop()}
            onConfirm={() => {
                props.onSortEnd(list)
                $msg('success', '设置成功')
                layerManage.pop()
            }}
        >
            <Column>
                <div data-color-000 data-font-size-14 data-margin-bottom-16>
                    可以对以下条目进行拖动排序：
                </div>
                {props.children}
                <div className={cls('list')}>
                    <SortList
                        distance={10}
                        axis="xy"
                        onSortEnd={({ oldIndex, newIndex }) => {
                            move(oldIndex, newIndex)
                        }}
                        helperClass="paymode-sort-helper"
                    />
                </div>
            </Column>
        </Modal>
    )
}

export default SortContainer
